import { Component, OnInit, OnDestroy, ViewChild, ElementRef, AfterViewInit, Input } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';

// elvispos
import { SAMService } from 'src/app/sam/sam.service';
import { ConfigService } from 'src/app/config.service';
import { SAMMessage } from 'src/app/sam/interfaces/sam-message';
import { ThemeService } from 'ngx-elvis-ds';
import { BasePage, Helpers } from 'ngx-elvis-ds';

export class InfoDialogCommands {
  public static OPEN = ['INFO_DIALOG_OPEN'];
  public static UPDATE = ['INFO_DIALOG_UPDATE'];
  public static CLOSE = ['INFO_DIALOG_CLOSE'];
}

@Component({
  selector: 'app-info-dialog',
  templateUrl: './info-dialog.page.html',
  styleUrls: ['./info-dialog.page.scss'],
})
export class InfoDialogPage extends BasePage implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('infoDialog', { static: true }) infoDialog: ElementRef;
  @Input() data: any = {};
  @Input() isLocal: boolean = false;

  constructor(
    public themeSvc: ThemeService,
    private sam: SAMService,
    private configSvc: ConfigService,
    private modalCtrl: ModalController,
  ) {
    super();
    this.subscribeListeners();
  }

  ngOnInit() {
    this.initstyle();
    this.subscriptions.themeEvents = this.themeSvc.events.subscribe(() => { this.initstyle(); });
  }

  ngAfterViewInit() {
    this.infoDialog.nativeElement.addEventListener('keydown', this.initKeyboard);
  }

  ngOnDestroy() {
    this.infoDialog.nativeElement.removeEventListener('keydown', this.initKeyboard);
    if (this.subscriptions.themeEvents) { this.subscriptions.themeEvents.unsubscribe(); }
  }

  onCallback() {
    if (this.isLocal) {
      this.modalCtrl.dismiss();
      return;
    }

    this.sam.onSend({
      Command: 'GENERIC_INPUT',
      Callback: this.data.Callback || 'OK'
    });
  }

  onCancelCallback() {
    if (this.isLocal) {
      this.modalCtrl.dismiss();
      return;
    }

    this.sam.onSend({
      Command: 'GENERIC_INPUT',
      Callback: this.data.CancelCallback || 'OK'
    });
  }

  // private

  private initKeyboard = (evt: any)  => {
    const event = evt || window.event;
    const key = event.key;

    if (key && (key === 'Escape' || key === 'Esc' || key === 'Enter')) { this.onCallback(); }

    return false;
  }

  private initstyle() {
    // if (setDefaults) { if (this.theme) { this.style.theme = this.theme; } }

    // if (!this.style.theme && this.themes.activeTheme) {
    //   this.theme = this.themes.activeTheme.style;
    // }

    // if (this.theme) {
    //   if (this.theme === 'dark') {
    //     this.infoDialog.nativeElement.style.setProperty('--mem-background-color', `var(--ion-color-${this.theme}`);
    //     this.infoDialog.nativeElement.style.setProperty('--mem-text-color', `var(--ion-color-light)`);
    //   } else {
    //     this.infoDialog.nativeElement.style.setProperty('--mem-background-color', `var(--ion-color-${this.theme}`);
    //     this.infoDialog.nativeElement.style.setProperty('--mem-text-color', `var(--ion-color-medium-shade)`);
    //   }
    // }
  }

  private subscribeListeners() {
    this.subscriptions.modalEventsListener = this.sam.channels.dialogs.subscribe((msg: SAMMessage) => {
      if (InfoDialogCommands.UPDATE.includes(msg.Command)) {
        const data: any = <any>msg.parms;

        this.data.Callback = data.Callback;
        this.data.Button = data.Button;
        this.data.CancelCallback = data.CancelCallback;
        this.data.CancelButton = data.CancelButton;

        if (data.Image) {
          const imageUrl = Helpers.imageUrl('info-dialog', data.Image, this.configSvc);
          this.data.imageUrl = imageUrl;
        }
        if (data.Info1) {
          this.data.Info1 = data.Info1;
        }
        if (data.Info2) {
          this.data.Info2 = data.Info2;
        }
        if (data.Info3) {
          this.data.Info3 = data.Info3;
        }
      }
    });
  }
}
